import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22555750"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ac-form-control w-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "productName" }, "Ürün Adı", -1))
const _hoisted_3 = { class: "flex gap-4" }
const _hoisted_4 = { class: "ac-form-control w-full" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "productBrand" }, "Marka", -1))
const _hoisted_6 = { value: null }
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "optional-label" }, "opsiyonel", -1))
const _hoisted_9 = { class: "ac-form-control w-full" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "supplier" }, "Tedarikçi", -1))
const _hoisted_11 = { value: null }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "optional-label" }, "opsiyonel", -1))
const _hoisted_14 = { class: "flex gap-4" }
const _hoisted_15 = { class: "ac-form-control w-full" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "productCategory" }, "Kategori", -1))
const _hoisted_17 = {
  value: null,
  disabled: ""
}
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "ac-form-control w-full" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "productSKU" }, "SKU / Stok Kodu", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "optional-label" }, "opsiyonel", -1))
const _hoisted_22 = { class: "flex gap-4" }
const _hoisted_23 = { class: "ac-form-control w-full" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "quantity" }, "Miktar", -1))
const _hoisted_25 = ["step"]
const _hoisted_26 = { class: "ac-form-control w-full" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "quantityType" }, "Miktar Birimi", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "flex gap-4" }
const _hoisted_30 = { class: "ac-form-control w-full" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unitPrice" }, "Birim Alış Fiyatı", -1))
const _hoisted_32 = { class: "ac-form-control w-full" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "purchaseCurrency" }, "Para Birimi", -1))
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "ac-form-control w-full" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "condition" }, "Durum", -1))
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "ac-form-control w-full" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "location" }, "Depo / Konum", -1))
const _hoisted_40 = { value: null }
const _hoisted_41 = ["value"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "optional-label" }, "opsiyonel", -1))
const _hoisted_43 = { class: "ac-form-control w-full" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "productDescription" }, "Ürün Açıklaması", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "optional-label" }, "opsiyonel", -1))
const _hoisted_46 = { class: "flex items-center justify-center gap-6 w-full" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "ac-primary-button text-2xl mt-4"
}, "Ürün Oluştur", -1))

import { ref } from "vue"
import { useGetDocs } from "@/mixins/modularFirebaseOperations"
import { quantityTypeOptions, currencyOptions, conditionOptions, requiresWholeUnits } from "@/composables/inventoryHelpers"
import type { AcInventoryItem, AcInventoryBatch, AcProductBrand, AcSupplier, AcProductCategory, AcInventoryLocation } from "@/types/inventory"


export default /*#__PURE__*/_defineComponent({
  __name: 'inventoryItemForm',
  emits: ["item-added", "cancel"],
  setup(__props, { emit: __emit }) {


const emit = __emit

// Meta lists for the dropdowns
const { docs: brands, isLoadingDocs: isLoadingBrands } = useGetDocs<AcProductBrand>("inventory/brands/list")
const { docs: suppliers, isLoadingDocs: isLoadingSuppliers } = useGetDocs<AcSupplier>("inventory/suppliers/list")
const { docs: categories, isLoadingDocs: isLoadingCategories } = useGetDocs<AcProductCategory>("inventory/categories/list")
const { docs: locations, isLoadingDocs: isLoadingLocations } = useGetDocs<AcInventoryLocation>("inventory/locations/list")

const productName = ref("")
const productBrand = ref<AcProductBrand | null>(null)
const supplier = ref<AcSupplier | null>(null)
const productCategory = ref<AcProductCategory | null>(null)
const productSKU = ref("")
const quantity = ref<number | null>(null)
const quantityType = ref<AcInventoryItem["quantityType"]>("PIECE")
const unitPrice = ref<number | null>(null)
const purchaseCurrency = ref<NonNullable<AcInventoryBatch["purchaseCurrency"]>>("TRY")
const condition = ref<NonNullable<AcInventoryBatch["condition"]>>("NEW")
const location = ref<AcInventoryLocation | null>(null)
const productDescription = ref("")

const saveItem = () => {
    if (!productName.value.trim()) {
        alert("Lütfen ürün adını giriniz.")
        return
    }
    if (!productCategory.value) {
        alert("Lütfen bir kategori seçiniz.")
        return
    }
    if (quantity.value === null || isNaN(Number(quantity.value)) || Number(quantity.value) <= 0) {
        alert("Lütfen geçerli bir miktar giriniz.")
        return
    }
    if (requiresWholeUnits(quantityType.value) && !Number.isInteger(Number(quantity.value))) {
        alert("Adet ile takip edilen ürünler için lütfen tam sayı giriniz.")
        return
    }
    if (unitPrice.value === null || isNaN(Number(unitPrice.value)) || Number(unitPrice.value) < 0) {
        alert("Lütfen geçerli bir birim alış fiyatı giriniz.")
        return
    }

    // The first batch is built by the list handler from these fields.
    const newItem: Partial<AcInventoryItem> = {
        productName: productName.value.trim(),
        productCategory: productCategory.value,
        quantity: Number(quantity.value),
        quantityType: quantityType.value,
        originalPrice: Number(unitPrice.value),
        purchaseCurrency: purchaseCurrency.value,
        condition: condition.value,
    }

    // Only include optional fields when provided
    if (productBrand.value) newItem.productBrand = productBrand.value
    if (supplier.value) newItem.supplier = supplier.value
    if (productSKU.value.trim()) newItem.productSKU = productSKU.value.trim()
    if (location.value) newItem.location = location.value
    if (productDescription.value.trim()) newItem.productDescription = productDescription.value.trim()

    emit("item-added", newItem)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(saveItem, ["prevent"]),
    class: "ac-main-form !border-none"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        id: "productName",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((productName).value = $event)),
        required: ""
      }, null, 512), [
        [_vModelText, productName.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          id: "productBrand",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((productBrand).value = $event)),
          class: "!py-3"
        }, [
          _createElementVNode("option", _hoisted_6, _toDisplayString(_unref(isLoadingBrands) ? 'Yükleniyor...' : 'Marka seçiniz'), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(brands), (brand) => {
            return (_openBlock(), _createElementBlock("option", {
              key: brand.id,
              value: brand
            }, _toDisplayString(brand.name), 9, _hoisted_7))
          }), 128))
        ], 512), [
          [_vModelSelect, productBrand.value]
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("select", {
          id: "supplier",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((supplier).value = $event)),
          class: "!py-3"
        }, [
          _createElementVNode("option", _hoisted_11, _toDisplayString(_unref(isLoadingSuppliers) ? 'Yükleniyor...' : 'Tedarikçi seçiniz'), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(suppliers), (sup) => {
            return (_openBlock(), _createElementBlock("option", {
              key: sup.id,
              value: sup
            }, _toDisplayString(sup.name), 9, _hoisted_12))
          }), 128))
        ], 512), [
          [_vModelSelect, supplier.value]
        ]),
        _hoisted_13
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _withDirectives(_createElementVNode("select", {
          id: "productCategory",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((productCategory).value = $event)),
          required: "",
          class: "!py-3"
        }, [
          _createElementVNode("option", _hoisted_17, _toDisplayString(_unref(isLoadingCategories) ? 'Yükleniyor...' : 'Kategori seçiniz'), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categories), (cat) => {
            return (_openBlock(), _createElementBlock("option", {
              key: cat.id,
              value: cat
            }, _toDisplayString(cat.name), 9, _hoisted_18))
          }), 128))
        ], 512), [
          [_vModelSelect, productCategory.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _withDirectives(_createElementVNode("input", {
          id: "productSKU",
          type: "text",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((productSKU).value = $event))
        }, null, 512), [
          [_vModelText, productSKU.value]
        ]),
        _hoisted_21
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _withDirectives(_createElementVNode("input", {
          id: "quantity",
          type: "number",
          min: "0",
          step: _unref(requiresWholeUnits)(quantityType.value) ? '1' : 'any',
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((quantity).value = $event)),
          required: ""
        }, null, 8, _hoisted_25), [
          [_vModelText, quantity.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _withDirectives(_createElementVNode("select", {
          id: "quantityType",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((quantityType).value = $event)),
          required: "",
          class: "!py-3"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quantityTypeOptions), (opt) => {
            return (_openBlock(), _createElementBlock("option", {
              key: opt.value,
              value: opt.value
            }, _toDisplayString(opt.label), 9, _hoisted_28))
          }), 128))
        ], 512), [
          [_vModelSelect, quantityType.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _withDirectives(_createElementVNode("input", {
          id: "unitPrice",
          type: "number",
          min: "0",
          step: "any",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((unitPrice).value = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, unitPrice.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _withDirectives(_createElementVNode("select", {
          id: "purchaseCurrency",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((purchaseCurrency).value = $event)),
          required: "",
          class: "!py-3"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyOptions), (opt) => {
            return (_openBlock(), _createElementBlock("option", {
              key: opt.value,
              value: opt.value
            }, _toDisplayString(opt.label), 9, _hoisted_34))
          }), 128))
        ], 512), [
          [_vModelSelect, purchaseCurrency.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _withDirectives(_createElementVNode("select", {
          id: "condition",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((condition).value = $event)),
          required: "",
          class: "!py-3"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conditionOptions), (opt) => {
            return (_openBlock(), _createElementBlock("option", {
              key: opt.value,
              value: opt.value
            }, _toDisplayString(opt.label), 9, _hoisted_37))
          }), 128))
        ], 512), [
          [_vModelSelect, condition.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _hoisted_39,
      _withDirectives(_createElementVNode("select", {
        id: "location",
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((location).value = $event)),
        class: "!py-3"
      }, [
        _createElementVNode("option", _hoisted_40, _toDisplayString(_unref(isLoadingLocations) ? 'Yükleniyor...' : 'Depo seçiniz'), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(locations), (loc) => {
          return (_openBlock(), _createElementBlock("option", {
            key: loc.id,
            value: loc
          }, _toDisplayString(loc.name), 9, _hoisted_41))
        }), 128))
      ], 512), [
        [_vModelSelect, location.value]
      ]),
      _hoisted_42
    ]),
    _createElementVNode("div", _hoisted_43, [
      _hoisted_44,
      _withDirectives(_createElementVNode("textarea", {
        id: "productDescription",
        rows: "3",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((productDescription).value = $event))
      }, null, 512), [
        [_vModelText, productDescription.value]
      ]),
      _hoisted_45
    ]),
    _createElementVNode("div", _hoisted_46, [
      _hoisted_47,
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('cancel'))),
        class: "ac-secondary-button text-2xl mt-4"
      }, "İptal")
    ])
  ], 32))
}
}

})